import React, { useState, useEffect, useRef } from "react";
import "../pages/PartnerPage.css";
import { useCommonVars } from "./useCommonVars";

export default function PartnerPage({ user, userDetails, btc, usdt, ton, eth }) {
  const [inviteCopyStatus, setInviteCopyStatus] = useState("");
  const { percents, channelUrl, chatUrl, supportUrl, referralLink } = useCommonVars(userDetails);
  const linkRef = useRef(null);

  useEffect(() => {
    const el = linkRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  }, [referralLink]);

  const copyText = async (text) => {
    let copied = false;
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        await navigator.clipboard.writeText(text);
        copied = true;
      }
    } catch {}
    if (!copied) {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        copied = true;
      } catch {}
    }
    setInviteCopyStatus(copied ? "Ссылка скопирована" : "❌ Не удалось скопировать");
    setTimeout(() => setInviteCopyStatus(""), 2000);
  };

  const handleCopyInviteLink = (text) => {
    copyText(text);
  };

  const handleClickLinkArea = () => {
    const el = linkRef.current;
    if (!el) return;
    el.focus();
    el.select();
    copyText(referralLink || "");
    el.blur();
  };

  const handleTelegramShare = () => {
    const url = referralLink || "";
    const text = "Присоединяйся по моей реферальной ссылке!";
    const tg = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.openTelegramLink(tg);
    } else {
      window.open(tg, "_blank", "noopener,noreferrer");
    }
  };

  const formatReferralEarnings = (amount) => {
    if (!amount) return "0₽";
    const num = parseFloat(amount);
    if (isNaN(num)) return "0₽";
    return num >= 1000 ? `${(num / 1000).toFixed(1)}К ₽` : `${num}₽`;
  };

  const totalReferrals =
    (userDetails?.referrals?.level1 || 0) +
    (userDetails?.referrals?.level2 || 0) +
    (userDetails?.referrals?.level3 || 0);

  return (
    <div className="main-container">
      <div className="referral-content">
        <p className="referral-heading">
          Приглашайте партнеров по ссылке,<br />
          получите <span className="highlight">{percents[0]}% с депозитов</span>
        </p>

        <div className="invite-section">
          <div className="pr-referral-link-block">
            <div className="pr-referral-link-title">Ваша реферальная ссылка</div>

            <div className="pr-ref-link-row">
              <textarea
                ref={linkRef}
                className="pr-ref-link-input"
                value={referralLink || ""}
                readOnly
                spellCheck={false}
                onClick={handleClickLinkArea}
                onFocus={(e) => e.target.select()}
              />
              <button
                className="pr-ref-copy-btn"
                onClick={(e) => {
                  const t = e.currentTarget;
                  const r = document.createElement("span");
                  r.className = "pr-ref-ripple";
                  const rect = t.getBoundingClientRect();
                  r.style.left = `${e.clientX - rect.left}px`;
                  r.style.top = `${e.clientY - rect.top}px`;
                  t.appendChild(r);
                  setTimeout(() => r.remove(), 500);
                  handleCopyInviteLink(referralLink || "");
                }}
              >
                Копировать
              </button>
            </div>

            <div className="pr-ref-stats">
              <div className="pr-ref-stat">
                <div className="pr-ref-stat-label">Заработано</div>
                <div className="pr-ref-stat-value">{formatReferralEarnings(userDetails?.partner_earnings)}</div>
              </div>
              <div className="pr-ref-divider" />
              <div className="pr-ref-stat">
                <div className="pr-ref-stat-label">Рефералов</div>
                <div className="pr-ref-stat-value">{totalReferrals}</div>
              </div>
            </div>

            <div className="pr-ref-actions">
              <button className="pr-ref-share-btn" onClick={handleTelegramShare}>
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path d="M9.5 14.2 18.9 6.7c.3-.2.1-.7-.3-.6L4.9 10.7c-.4.1-.4.7 0 .8l3.8 1.2 1 3.9c.1.4.6.5.8.2l2.1-2.7 4.1 3c.3.2.7 0 .8-.3l3-12.3" fill="currentColor"/>
                </svg>
                Поделиться в Telegram
              </button>
            </div>
          </div>

          {inviteCopyStatus && <div className="invite-toast">{inviteCopyStatus}</div>}

          <div className="rules-box">
            <div className="rules-title">Правила приглашения партнеров</div>
            <div className="rules-text">
              Пригласите партнера по своей ссылке, далее после пополнения им депозита вы получите % на свой баланс
            </div>
          </div>
        </div>
      </div>

      <div className="scrollable-area">
        <div className="referral-card-full">
          <div className="referral-card">
            <div className="circle circle-left-border"></div>
            <div className="circle circle-right-bg-top"></div>
            <div className="circle circle-right-border"></div>
            <div className="circle circle-right-bg-bottom"></div>
            <div className="referral-card-text">
              Наш проект поддерживает <span className="nowrap">3-х</span><span className="highlight">&nbsp;уровневую партнёрскую программу.</span> <br />
              <strong>Это значит</strong>, что вы будете зарабатывать не только со своих партнеров, а также с людей, которых пригласили ваши партнеры.<br /><br />
              <span className="highlight">Партнерские отчисления</span> по уровням:<br /><br />
              <span className="highlight">1 уровень: {percents[0]}% от суммы депозита.</span><br />
              <span className="highlight">2 уровень: {percents[1]}% от суммы депозита.</span><br />
              <span className="highlight">3 уровень: {percents[2]}% от суммы депозита.</span><br /><br />
              <span className="section-title">Как работает 3-х уровневая партнерская программа?</span><br />
              <span className="highlight">- 1 уровень — это те, кого пригласили вы, 2 уровень — это те, кого пригласили они, и так далее.</span><br /><br />
              <span className="section-title">Куда зачисляются средства после пополнения депозита партнером?</span><br />
              <span className="highlight">- Партнерские отчисления зачисляются в раздел "Кошелек", следовательно их можно сразу же вывести.</span>
            </div>
          </div>
        </div>
      </div>

      <div className="info-wrapper">
        <div className="info-section">
          <div className="info-title">Информация</div>
          <div className="info-support">
            <div className="support-links">
              <a href={supportUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Поддержка">
                <span className="icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M4 15V11C4 6.582 7.582 3 12 3C16.418 3 20 6.582 20 11V15" stroke="currentColor" strokeWidth="2"/>
                    <rect x="2" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <rect x="17" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M12 21V19" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </span>
                Поддержка
              </a>
              <span className="dot-sep">·</span>
              <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Канал">
                <span className="icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M21 3L3 10.53L8.38 12.06L18.25 6.03C18.66 5.78 19.08 6.22 18.82 6.62L12.38 16.5V16.5L12.37 16.5L12.38 16.5V16.5L14.12 20.16C14.34 20.62 14.97 20.65 15.24 20.21L21 3Z" fill="currentColor"/>
                  </svg>
                </span>
                Канал
              </a>
              <span className="dot-sep">·</span>
              <a href={chatUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Чат">
                <span className="icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5709 20 9.22432 19.7453 8.02781 19.2929L3 20.5L4.20711 15.6725C3.44217 14.5208 3 13.0716 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                  </svg>
                </span>
                Чат
              </a>
            </div>
          </div>
          <div className="info-subtitle">Партнерская программа</div>
          <div className="info-icons-box">
            <img src={btc} alt="btc" className="coin-icon" />
            <img src={usdt} alt="usdt" className="coin-icon" />
            <img src={ton} alt="ton" className="coin-icon" />
            <img src={eth} alt="eth" className="coin-icon" />
          </div>
          <div className="copyright">© 2025 | Все права защищены.</div>
        </div>
      </div>
    </div>
  );
}
